import { Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterModule } from "@angular/router";
import { ActiveRoute } from '../active-route';

@Component({
  selector: 'app-nav',
  standalone: true,
  imports: [ RouterLinkActive,
    RouterModule
  ],
  templateUrl: './nav.html',
  styleUrl: './nav.scss',
})
export class Nav {
  isMenuVisible:boolean=false;
  activeRouteService= inject(ActiveRoute)
  
}
